import { Archive, ChevronDown, HeartPulse } from 'lucide-react'
import type { ReactNode } from 'react'
import { Button } from '@/components/ui/Button'
import {
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuRoot,
  DropdownMenuTrigger,
} from '@/components/ui/DropdownMenu'

export type ChannelAction = 'archive-weak' | 'recovery'

export interface ChannelActionsMenuProps {
  channelName: string
  onAction: (action: ChannelAction) => void
}

interface ActionItem {
  action: ChannelAction
  label: string
  icon: ReactNode
}

/**
 * "Ações do canal" na barra de Projetos (docs/plan-channel-recovery.md). Os
 * itens são uma lista: uma ação nova de "ressuscitar canal" entra aqui sem
 * mexer no resto.
 */
const ITEMS: readonly ActionItem[] = [
  { action: 'archive-weak', label: 'Arquivar vídeos fracos…', icon: <Archive /> },
  { action: 'recovery', label: 'Recuperar canal', icon: <HeartPulse /> },
]

export function ChannelActionsMenu({ channelName, onAction }: ChannelActionsMenuProps) {
  return (
    <DropdownMenuRoot>
      <DropdownMenuTrigger asChild>
        <Button
          variant="secondary"
          trailingIcon={<ChevronDown />}
          aria-label={`Ações do canal — ${channelName}`}
        >
          Ações do canal
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {ITEMS.map((item) => (
          <DropdownMenuItem
            key={item.action}
            leadingIcon={item.icon}
            onSelect={() => {
              onAction(item.action)
            }}
          >
            {item.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenuRoot>
  )
}
